import { LoadingScreen } from '@ibinder/common-frontend';
import React from 'react';
import { AuthConsumer } from './AuthProvider';

export const SigninRedirect = ({
  tryLogin,
  waitText
}: {
  tryLogin: string;
  waitText: string;
}) => {
  const qs = new URLSearchParams(location.search);
  const path = qs.get('path') ? qs.get('path') : '/';
  return (
    <AuthConsumer>
      {({ signinRedirect }) => {
        signinRedirect(path);
        return (
          <LoadingScreen
            statusMessage={tryLogin}
            loadingText={waitText}
            fullscreen={true}
          />
        );
      }}
    </AuthConsumer>
  );
};
